<template>
  <button
    :id="`performance-${displayPerformance.id}`"
    class="transition-opacity py-2 px-8 rounded font-semibold text-sm font-button bg-button-guest-primary text-button-label enabled:hover:opacity-80 disabled:cursor-not-allowed disabled:bg-disabled"
    :disabled="displayPerformance.sold || displayPerformance.isPast"
    @click="onClick"
  >
    {{ displayPerformance.timeStr }} SHOW
    <span v-if="displayPerformance.sold">( SOLD OUT )</span>
  </button>
</template>
<script lang="ts">
import { mapStores } from 'pinia'
import { PropType, defineComponent } from 'vue'

import { StorePerformance } from '@/models'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'
import { ErrorData } from '@/utils/errors'
import { todayIsoStr } from '@/utils/utils'

interface DisplayPerformance extends StorePerformance {
  timeStr: string
  isPast: boolean
}
export default defineComponent({
  name: 'PerformanceButton',
  emits: {
    // eslint-disable-next-line no-unused-vars
    click: (performance: DisplayPerformance) => true,
  },
  props: {
    error: { type: Object as PropType<ErrorData>, required: true },
    performance: { type: Object as PropType<StorePerformance>, required: true },
  },
  computed: {
    ...mapStores(useSettingStore, useCheckoutStore),
    displayPerformance(): DisplayPerformance {
      const current = todayIsoStr()
      return {
        ...this.performance,
        timeStr: this.settingStore.timeStr(this.performance.datetime),
        isPast: this.performance.date < current,
      }
    },
  },
  methods: {
    async onClick() {
      if (this.displayPerformance.sold) return
      this.$emit('click', this.displayPerformance)
      this.checkoutStore.setPerformance(this.displayPerformance, this.error)
    },
  },
})
</script>
